import { addMessages } from '@hana/i18n';

// Khoá chuỗi rqa.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'rqa.1': "Duyệt",
  'rqa.2': "Trả về",
  'rqa.3': "Quyết toán theo người ↗",
  'rqa.4': "còn",
});
addMessages('en', {
  'rqa.1': "Approve",
  'rqa.2': "Return",
  'rqa.3': "Settle by person ↗",
  'rqa.4': "left",
});
